export default class SubscriberTransferSearch {
  socialSecurityNumber: string;
  eligibilityDate: Date;
  sebbIsNewlyEligibleBeforeFirstDayOfSchool? = false;
  selfPayAgencyCode: string;
}
